import React from "react";
import { Button, Form, Input } from "antd";
import PropTypes from "prop-types";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import {
  conceptNoteCellStyle,
  conceptNoteTableStyle,
  invitedParticipantColumns,
} from "./conceptNoteFields";

const InvitedParticipantsInput = ({ readOnly = false }) => {
  return (
    <Form.List name="invited_participants">
      {(fields, { add, remove }) => (
        <>
          <table
            className="table table-sm table-bordered mb-2"
            style={conceptNoteTableStyle}
          >
            <thead className="table-light">
              <tr>
                {invitedParticipantColumns.map((column) => (
                  <th key={column.name}>{column.label}</th>
                ))}
                {!readOnly && <th style={{ width: 40 }} />}
              </tr>
            </thead>
            <tbody>
              {fields.length === 0 && (
                <tr>
                  <td
                    colSpan={invitedParticipantColumns.length + 1}
                    className="text-center text-secondary"
                  >
                    No participants added
                  </td>
                </tr>
              )}
              {fields.map(({ key, name }) => (
                <tr key={key}>
                  {invitedParticipantColumns.map((column) => (
                    <td key={column.name} style={conceptNoteCellStyle}>
                      <Form.Item name={[name, column.name]} className="mb-0">
                        <Input.TextArea
                          variant="borderless"
                          placeholder={column.label}
                          readOnly={readOnly}
                          autoSize={{ minRows: 1 }}
                        />
                      </Form.Item>
                    </td>
                  ))}
                  {!readOnly && (
                    <td className="text-center align-middle">
                      <Button
                        type="text"
                        danger
                        size="small"
                        icon={<AiOutlineDelete />}
                        onClick={() => remove(name)}
                      />
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          {!readOnly && (
            <Button
              type="dashed"
              size="small"
              icon={<AiOutlinePlus />}
              onClick={() => add({})}
            >
              Add Participant
            </Button>
          )}
        </>
      )}
    </Form.List>
  );
};

InvitedParticipantsInput.propTypes = {
  readOnly: PropTypes.bool,
};

export default InvitedParticipantsInput;
